/**
 * StageCaption — why the stage just moved ("Likely causes: wet oil and a sticky non-return valve"),
 * shown over the centre stage for 6 s after each new caption. Schedule-triggered cases also show
 * the scenario clock ("06:45 scenario time").
 *
 * `caption` is a string or {text, key}; a new key re-shows the same text.
 */

import { useEffect, useState } from 'react';
import SpecialistDot from './SpecialistDot.jsx';
import './StageCaption.css';

const SHOW_MS = 6000;

export default function StageCaption({ caption = null, specialist = null, scenarioClock = null }) {
  const text = typeof caption === 'string' ? caption : caption?.text ?? null;
  const key = typeof caption === 'string' ? caption : `${caption?.key ?? ''}|${caption?.text ?? ''}`;
  const [expiredKey, setExpiredKey] = useState(null);

  useEffect(() => {
    if (!text) return undefined;
    const timer = setTimeout(() => setExpiredKey(key), SHOW_MS);
    return () => clearTimeout(timer);
  }, [key, text]);

  const visible = Boolean(text) && expiredKey !== key;
  if (!visible && !scenarioClock) return null;

  return (
    <div className="scap" role="status" aria-live="polite">
      {visible && (
        <div className="scap__caption" key={key}>
          <SpecialistDot specialist={specialist} />
          <span className="scap__text">{text}</span>
        </div>
      )}
      {scenarioClock && <div className="scap__clock">{`${scenarioClock} scenario time`}</div>}
    </div>
  );
}
